import styled from "styled-components";
import { FormControl } from "@material-ui/core";

export const StyledFormControl = styled(FormControl)`
    min-width: 140px;
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "auto")};
`;
